import styles from "../../../styles/Forms.module.css";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { useFormik } from "formik";
import {
  getStatementTypes,
  getUserContractReceiptInAccounts,
} from "../../../store/SharedSlice";
import FormatDate from "../../../components/DateFunctions/FormatDate";
import {
  getExpenseList,
  getExpenseListById,
  updateExpenseList,
} from "../../../store/AccountingSlice";
import { useNavigate, useParams } from "react-router-dom";
import ReturnToFormate from "../../../components/DateFunctions/ReturnToFormate";

const EditeListExpenses = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const {
    UserContractReceiptInAccountsArray,
    StatementTypesArray,
  } = useSelector((state) => state.SharedSlice);
  const { ExpenseListByIdArray } = useSelector(
    (state) => state.AccountingSlice
  );

  useEffect(() => {
    dispatch(getExpenseListById(id));
  }, [dispatch, id]);
  useEffect(() => {
    if (!UserContractReceiptInAccountsArray) {
      dispatch(getUserContractReceiptInAccounts());
    }
  }, [dispatch, UserContractReceiptInAccountsArray]);
  useEffect(() => {
    if (!StatementTypesArray) {
      dispatch(getStatementTypes());
    }
  }, [dispatch, StatementTypesArray]);
  const toast = useRef(null);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: id,
      statement_type_id: ExpenseListByIdArray?.statementType?.id || null, // statement_types table
      receipt_in_account_id: ExpenseListByIdArray?.receiptInAccount?.id || null, // receipt_in_account table
      date: ExpenseListByIdArray
        ? ReturnToFormate(ExpenseListByIdArray?.date)
        : "",
      price: ExpenseListByIdArray?.price || "",
      price_arabic: ExpenseListByIdArray?.price_arabic || "",
      number_of_payments: ExpenseListByIdArray?.number_of_payments || "",
      user_name: ExpenseListByIdArray?.price || "",
      paid_type: ExpenseListByIdArray?.paid_type || null, //cash,check,card,transfer
      plan_type: ExpenseListByIdArray?.plan_type || null, //Monthly, bimonthly, quarterly, semi-annually,annually
      finance_type: ExpenseListByIdArray?.finance_type || null, //user,company,employee
      note: ExpenseListByIdArray?.note || "",
    },
    validate: (data) => {
      const errors = {};
      if (!data.date) errors.date = "التاريخ مطلوب.";
      if (!data.statement_type_id) errors.statement_type_id = "البيان مطلوب.";
      if (!data.receipt_in_account_id)
        errors.receipt_in_account_id = "من حساب مطلوب.";
      if (!data.number_of_payments)
        errors.number_of_payments = "عدد الدفعات مطلوب.";
      if (!data.price) errors.price = " القيمة مطلوبة.";
      if (!data.plan_type) errors.plan_type = "الخطة مطلوبة.";
      if (!data.price_arabic)
        errors.price_arabic = " القيمة باللغة العربية مطلوبة.";
      if (!data.user_name) errors.user_name = " الاسم مطلوب.";
      if (!data.paid_type) errors.paid_type = " طريقة الدفع مطلوبة.";
      if (!data.finance_type) errors.finance_type = " نوع التمويل مطلوب";
      if (!data.note) errors.note = " الملاحظات مطلوبة.";

      return errors;
    },
    onSubmit: (data) => {
      if (data) {
        const Data = { ...data, date: FormatDate(data.date) };
        dispatch(updateExpenseList(Data))
          .unwrap()
          .then(() => {
            dispatch(getExpenseList());
            navigate("/ListExpenses");
          })
          .cathc((err) => {
            Error(err[0]);
          });
      }
    },
  });

  const isFieldInvalid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);

  const getFormErrorMessage = (name) =>
    isFieldInvalid(name) ? (
      <small className="p-error">{formik.errors[name]}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );

  const PaymentOptions = [
    { name: "كاش", id: "cash" },
    { name: "شيك", id: "check" },
    { name: "كارت", id: "card" },
    { name: "تحويل", id: "transfer" },
  ];
  const PlanOptions = [
    { name: "شهرياً", id: "Monthly" },
    { name: "كل شهرين", id: "bimonthly" },
    { name: "ربع سنوي", id: "quarterly" },
    { name: "نصف سنوي", id: "semi-annually" },
    { name: "سنوي", id: "annually" },
  ];
  const FinanceOptions = [
    { name: "العميل", id: "user" },
    { name: "الشركة", id: "company" },
    { name: "الموظف", id: "employee" },
  ];
  const Error = (mess) => {
    toast.current.show({
      severity: "error",
      summary: `${mess}`,
      life: 3000,
    });
  };
  return (
    <div className="container-fluid">
      <Toast ref={toast} position="top-left" />

      <div className=" card_info   ">
        <legend> خطة الصرف</legend>
        <form onSubmit={formik.handleSubmit}>
          <div className="grid align-items-center">
            <div className="col-12 md:col-3">
              <div className={styles.inputFormik2}>
                <div className={styles.Signup_container}>
                  <label htmlFor="user_name">الاسم</label>
                  <InputText
                    id="user_name"
                    name="user_name"
                    value={formik.values.user_name}
                    onChange={(e) =>
                      formik.setFieldValue("user_name", e.target.value)
                    }
                  />
                </div>
                {getFormErrorMessage("user_name")}
              </div>
            </div>
            <div className="col-12 md:col-3">
              <div className={styles.inputFormik2}>
                <div className={styles.Signup_container}>
                  <label htmlFor="date">التاريخ</label>
                  <Calendar
                    id="Calendar"
                    value={formik.values.date}
                    onChange={(e) => formik.setFieldValue("date", e.value)}
                    showIcon
                    dateFormat="yy-mm-dd"
                  />
                </div>
                {getFormErrorMessage("date")}
              </div>
            </div>
            <div className="col-12 md:col-3">
              <div className={styles.inputFormik2}>
                <div className={styles.Signup_container}>
                  <label htmlFor="plan_type">الخطة </label>
                  <Dropdown
                    value={formik.values.plan_type}
                    onChange={(e) => formik.setFieldValue("plan_type", e.value)}
                    options={PlanOptions}
                    optionLabel="name"
                    optionValue="id"
                  />
                </div>
                {getFormErrorMessage("plan_type")}
              </div>
            </div>
            <div className="col-12 md:col-3">
              <div className={styles.inputFormik2}>
                <div className={styles.Signup_container}>
                  <label htmlFor="finance_type">نوع التمويل </label>
                  <Dropdown
                    value={formik.values.finance_type}
                    onChange={(e) =>
                      formik.setFieldValue("finance_type", e.value)
                    }
                    options={FinanceOptions}
                    optionLabel="name"
                    optionValue="id"
                  />
                </div>
                {getFormErrorMessage("finance_type")}
              </div>
            </div>
            <div className="col-12 md:col-3">
              <div className={styles.inputFormik2}>
                <div className={styles.Signup_container}>
                  <label htmlFor="statement_type_id">البيان</label>
                  {StatementTypesArray && (
                    <Dropdown
                      filter
                      filterBy="name"
                      id="statement_type_id"
                      name="statement_type_id"
                      value={formik.values.statement_type_id}
                      options={StatementTypesArray}
                      optionLabel="name"
                      optionValue="id"
                      onChange={(e) =>
                        formik.setFieldValue(
                          "statement_type_id",
                          e.target.value
                        )
                      }
                    />
                  )}
                </div>
                {getFormErrorMessage("statement_type_id")}
              </div>
            </div>

            <div className="col-12 md:col-3">
              <div className={styles.inputFormik2}>
                <div className={styles.Signup_container}>
                  <label htmlFor="receipt_in_account_id">من حساب </label>
                  {UserContractReceiptInAccountsArray && (
                    <Dropdown
                      filter
                      filterBy="name"
                      value={formik.values.receipt_in_account_id}
                      onChange={(e) =>
                        formik.setFieldValue("receipt_in_account_id", e.value)
                      }
                      options={UserContractReceiptInAccountsArray}
                      optionLabel="name"
                      optionValue="id"
                    />
                  )}
                </div>
                {getFormErrorMessage("receipt_in_account_id")}
              </div>
            </div>
            <div className="col-12 md:col-3">
              <div className={styles.inputFormik2}>
                <div className={styles.Signup_container}>
                  <label htmlFor="number_of_payments">عدد الدفعات </label>
                  <InputText
                    keyfilter={"num"}
                    id="number_of_payments"
                    name="number_of_payments"
                    value={formik.values.number_of_payments}
                    onChange={(e) =>
                      formik.setFieldValue("number_of_payments", e.target.value)
                    }
                  />
                </div>
                {getFormErrorMessage("number_of_payments")}
              </div>
            </div>
            <div className="col-12 md:col-3">
              <div className={styles.inputFormik2}>
                <div className={styles.Signup_container}>
                  <label htmlFor="paid_type">طريقة الدفع</label>
                  <Dropdown
                    value={formik.values.paid_type}
                    onChange={(e) => formik.setFieldValue("paid_type", e.value)}
                    options={PaymentOptions}
                    optionLabel="name"
                    optionValue="id"
                  />
                </div>
                {getFormErrorMessage("paid_type")}
              </div>
            </div>
            <div className="col-12 md:col-3">
              <div className={styles.inputFormik2}>
                <div className={styles.Signup_container}>
                  <label htmlFor="price">القيمة</label>
                  <InputText
                    keyfilter={"num"}
                    id="price"
                    name="price"
                    value={formik.values.price}
                    onChange={(e) =>
                      formik.setFieldValue("price", e.target.value)
                    }
                  />
                </div>
                {getFormErrorMessage("price")}
              </div>
            </div>
            <div className="col-12 md:col-3">
              <div className={styles.inputFormik2}>
                <div className={styles.Signup_container}>
                  <label htmlFor="price_arabic">القيمة باللغة العربية</label>
                  <InputText
                    id="price_arabic"
                    name="price_arabic"
                    value={formik.values.price_arabic}
                    onChange={(e) =>
                      formik.setFieldValue("price_arabic", e.target.value)
                    }
                  />
                </div>
                {getFormErrorMessage("price_arabic")}
              </div>
            </div>

            <div className="col-12 md:col-6">
              <div className={styles.inputFormik2}>
                <div className={styles.Signup_container}>
                  <label htmlFor="note">ملاحظات</label>
                  <InputText
                    id="note"
                    name="note"
                    value={formik.values.note}
                    onChange={(e) =>
                      formik.setFieldValue("note", e.target.value)
                    }
                  />
                </div>
                {getFormErrorMessage("note")}
              </div>
            </div>

            <div className="col-12 md:col-12">
              <div className="StatusBtn mt-auto mr-auto">
                <button className="add_btn mx-auto mr-auto" type="submit">
                  حفظ
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditeListExpenses;
